import React, { useRef } from "react";
import { useMediaQuery } from "react-responsive";

const SectionTwo  = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className="section-two-mig-ind">
      <div className="section-two-mig-ind-container">
        <div className="sec-two-mig-ind-header">
          <h2 className="sec-two-mig-ind-head-1" style={{ fontWeight: "400" }}>
            Tap into GoKwik's
          </h2>
          <h2 className="sec-two-mig-ind-head-2" style={{ fontWeight: "400" }}>
            165 M+ Shoppers Network
          </h2>
          <p className="sec-two-mig-ind-subhead">
            Access the largest network of online shoppers to boost engagement
            and conversions
          </p>

          {isMobile ? (
            <div className="network-sec-two-mig-ind-mob">
              <img
                src="/assets/images/custom-checkout/risk.png"
                style={{ transform: "rotate(8deg)", width: "95%" }}
                alt=""
              />
              <img
                style={{ transform: "rotate(0deg)" }}
                src="/assets/images/custom-checkout/data-points.png"
                alt=""
              />
              <img
                src="/assets/images/custom-checkout/orders.png"
                style={{ transform: "rotate(-8deg)", width: "95%" }}
                alt=""
              />
            </div>
          ) : (
            <div className="network-sec-two-mig-ind">
              <img src="/assets/images/custom-checkout/frame1.png" alt="" />
              <img src="/assets/images/custom-checkout/frame2.png" alt="" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SectionTwo;
